import { useQuery } from '@apollo/client'
import { Card, PageHeading, Page } from 'admin-web-ui'
import gql from 'graphql-tag'
import React from 'react'
import { useParams } from 'react-router'
import styled from 'styled-components'
import { UpdateAccountUserForm } from './UpdateAccountUserForm'

export const GET_PAGE_DATA = gql`
  query user($username: ID!) {
    user(username: $username) {
      username
      emailAddress
      firstName
      lastName
      groups
      status
      enabled
    }
    customer {
      projects {
        id
        name
      }
    }
  }
`

export const UserNotFound = styled.div`
  text-align: center;
  margin-top: 50px;
  h2 {
    font-weight: bold;
  }
`

export const UpdateAccountUser = (): React.ReactElement => {
  const { id: username } = useParams<{ id: string }>()
  const { loading, data, error } = useQuery(GET_PAGE_DATA, {
    fetchPolicy: 'cache-and-network',
    variables: {
      username,
    },
  })

  return (
    <Page>
      {error ? (
        <UserNotFound>
          <h2>There was trouble finding what you were looking for</h2>
          <p>
            Make sure the person you&apos;re trying to reach exists within this
            project
          </p>
        </UserNotFound>
      ) : (
        <>
          <PageHeading>Edit Account User</PageHeading>
          <Card loading={loading}>
            {data && (
              <UpdateAccountUserForm
                user={data.user}
                projects={data.customer.projects}
              />
            )}
          </Card>
        </>
      )}
    </Page>
  )
}
